import React from 'react';
import { useTranslation } from 'react-i18next';
import BreadCrumb from 'src/components/breadCrumb';
import DocumentsList from 'src/components/documentsList';
import ScreenContainer from 'src/components/screenContainer';
import { DOCUMENT_TYPE_KEY, MEDICAL_HISTORY } from 'src/enums';
import { documentsSelectors, useSelector } from 'src/store';

interface IReleaseDocsProps {
  exa?: string;
}

const ReleaseDocs: React.FunctionComponent<IReleaseDocsProps> = () => {
  // TOOLS
  const { t } = useTranslation();

  // SELECTORS
  const allDocuments = useSelector(documentsSelectors.selectDocumentsData);

  const formatData = () => {
    if (allDocuments?.ReleaseDocList) {
      return allDocuments?.ReleaseDocList.filter(
        (document) => document.caseType === DOCUMENT_TYPE_KEY.RELEASE_DOCS
      ).map((item) => {
        // this mapping is because in the table component we use "_id"
        return {
          ...item,
          _id: item.docNum
        };
      });
    }
    return [];
  };

  // VIEW
  return (
    <ScreenContainer>
      <BreadCrumb />
      <DocumentsList
        list={formatData()}
        activeKey={MEDICAL_HISTORY.RELEASE_DOCS}
      />
    </ScreenContainer>
  );
};

export default ReleaseDocs;
